export default {
  "head": {
    "title": "实时大数据Meetup"
  },
  "微信分享": {
    "标题": "2018实时大数据Meetup",
    "介绍": "9月8日9:30-12:30，大咖论道最火爆的实时大数据技术沙龙～",
    "图片": "http://static.geekbang.org/infoq/5a22b2b55dde6.png?imageView2/0/w/800"
  },
  "导航栏": {
    "list": [
      {
        "name": "活动介绍",
        "link": "#toutiao",
        "是否显示": true
      },
      {
        "name": "讲师介绍",
        "link": "#speakers",
        "是否显示": true
      },
      {
        "name": "大会报道",
        "link": "#news",
        "是否显示": false
      },
      {
        "name": "相关资讯",
        "link": "#relative",
        "是否显示": false
      },
      {
        "name": "Meetup日程",
        "link": "#schedule",
        "是否显示": true
      },
      {
        "name": "会场花絮",
        "link": "#live",
        "是否显示": false
      },
      {
        "name": "精彩瞬间",
        "link": "#image",
        "是否显示": false
      },
      {
        "name": "视频直击",
        "link": "#video",
        "是否显示": false
      },
      {
        "name": "合作伙伴",
        "link": "#partners",
        "是否显示": true
      }
    ]
  },
  "banner": {
    "link": "javascript:;",
    "图片（pc）": "https://static.geekbang.org/infoq/5b923b4ea6320.png",
    "图片（mobile）": "https://static.geekbang.org/infoq/5b923b033b83e.png"
  },
  "头条新闻": {
    "是否显示": true,
    "title": {
      "h1": "活动介绍",
      "h2": "Activity Introduction"
    },
    "图片": "https://static.geekbang.org/infoq/5b925c49e51b2.png",
    "right": {
      "标题": "2018实时大数据Meetup——Spark、Flink、CarbonData的技术与实践",
      "介绍": "本次Meetup活动集合了来自Databricks、华为及美团的大咖级嘉宾，这些嘉宾长期活跃在Apache开源社区，并担任PMC和Committer关键技术角色，试图以更开放的技术视角为大家解密Spark、Flink、CarbonData的技术和实践",
      "more": "查看议题详情>>",
      "link": "https://www.bagevent.com/event/1793784"
    }
  },
  "讲师介绍": {
    "是否显示": true,
    "title": {
      "h1": "讲师介绍",
      "h2": "Speaker Introduction"
    },
    "list": [
      {
        "id": "2357",
        "图片": "https://static.geekbang.org/infoq/5b924c1824f8c.png?imageView2/0/w/800",
        "name": "Tathagata Das",
        "company": "Databricks",
        "position": "Apache Spark PMC",
        "introduce": "Brilliant gentle man",
        "link": "javascript:;"
      },
      {
        "id": "2357",
        "图片": "https://static.geekbang.org/infoq/5b924cba5ef44.png?imageView2/0/w/800",
        "name": "蔡强",
        "company": "华为",
        "position": "大数据架构师",
        "introduce": "Brilliant gentle man",
        "link": "javascript:;"
      },
      {
        "id": "2357",
        "图片": "https://static.geekbang.org/infoq/5b924ba7b402e.png?imageView2/0/w/800",
        "name": "孙梦瑶",
        "company": "美团点评",
        "position": "高级工程师",
        "introduce": "Brilliant gentle man",
        "link": "javascript:;"
      },
      {
        "id": "2357",
        "图片": "https://static.geekbang.org/infoq/5b924ce560262.png?imageView2/0/w/800",
        "name": "时金魁",
        "company": "华为云",
        "position": "技术专家",
        "introduce": "Brilliant gentle man",
        "link": "javascript:;"
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      }
    ],
    "图片": "https://static.geekbang.org/infoq/5b7faf1f3b7d3.png?imageView2/0/w/800",
    "right": {
      "标题": "华为“云+未来”峰会亮相山城，助力重庆成为数字中国新标杆",
      "介绍": "8月23日，2018华为“云+未来”重庆峰会亮相首届中国国际智能产业博览会（智博会）。峰会现场，华为首度分享了西南地区及重庆最新用云量数据，并带来可助力重庆智造与智慧民生的新“智能引擎”——行业超级大脑。此外，全国首个区域级全域智慧旅游平台“一部手机游武隆”也正式与公众见面。",
      "more": "查看全文>>",
      "link": "http://www.infoq.com/cn/news/2018/08/Tencent-cloud-summit-Chongqing"
    }
  },
  "实时报道": {
    "是否显示": false,
    "title": {
      "h1": "大会报道",
      "h2": "Meeting Reportings"
    },
    "list": []
  },
  "相关新闻": {
    "是否显示": false,
    "title": {
      "h1": "相关资讯",
      "h2": "Related News"
    },
    "list": [],
    "more": {
      "name": "查看更多>>",
      "link": "http://www.infoq.com/cn/tencent-cloud"
    }
  },
  "大会日程": {
    "是否显示": true,
    "title": {
      "h1": "大会日程",
      "h2": "AGENDA"
    },
    "图片（pc）": "https://static.geekbang.org/infoq/5aeaa9422d08d.png",
    "图片（mobile）": "https://static.geekbang.org/infoq/5aeaa9427cfe6.png"
  },
  "会场花絮": {
    "是否显示": 0,
    "title": {
      "h1": "会场花絮",
      "h2": "Live"
    },
    "list": []
  },
  "现场图片": {
    "是否显示": false,
    "title": {
      "h1": "精彩瞬间",
      "h2": "Photos"
    },
    "图片链接": [],
    "more": "",
    "link": "https://www.geekbang.org"
  },
  "视频回放": {
    "是否显示": false,
    "title": {
      "h1": "视频直击",
      "h2": "Video"
    },
    "list": []
  },
  "合作伙伴": {
    "是否显示": true,
    "title": {
      "h1": "合作伙伴",
      "h2": "Partners"
    },
    "list": [
      {
        "avatar": "https://static.geekbang.org/infoq/5b9250163cb47.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": "极客邦科技"
      },
      {
        "avatar": "https://static.geekbang.org/infoq/5b9252c77a567.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": "华为云"
      },
      {
        "avatar": "https://static.geekbang.org/infoq/5b924fd0bf954.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": "infoq"
      },
      {
        "avatar": "https://static.geekbang.org/infoq/5b9253986431b.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": ""
      },
      {
        "avatar": "https://static.geekbang.org/infoq/5b9253bd5b741.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": ""
      },
      {
        "avatar": "https://static.geekbang.org/infoq/5b92535244dcc.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": "大咖说"
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/data.js